/**
 * Enum for RelAttribute.
 */
export enum RelAttribute {
  PreventReferrer = 'noopener noreferrer',
  PreventReferrerAndFollow = 'noopener noreferrer nofollow',
}
